import { Component, Input, OnChanges, OnInit, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { ComponentBase } from 't4core';

@Component({
  selector: 't4-threestate',
  templateUrl: './ThreeStateCheckBox.html',
  styleUrls: ['./ThreeStateCheckBox.css'],
})
export class ThreeStateCheckBox extends ComponentBase implements OnInit, OnChanges {

  @Input() public disabled: boolean;
  @Input() value!: boolean;
  @Output() valueChange = new EventEmitter<boolean>();

  public checked: boolean = false;
  public indeterminate: boolean = false;


  public async ngOnInit() {
    
  }


  ngOnChanges(changes: SimpleChanges) {
    if (this.value == true) {
      this.indeterminate = false;
      this.checked = true;
    }
    else if (this.value == false) {
      this.checked = false;
      this.indeterminate = false;
    }
    else if (this.value == null || this.value == undefined) {
      this.checked = false;
      this.indeterminate = true;
    }
  }

  public toggle() {
    if (this.value == true) {
      this.indeterminate = true;
      this.value = undefined;
      this.checked = false;
    }
    else if (this.value == false) {
      this.value = true;
      this.checked = true;
      this.indeterminate = false;
    }
    else if (this.value == null || this.value == undefined) {
      this.value = false;
      this.checked = false;

      this.indeterminate = false;
    }

    this.valueChange.emit(this.value);
    return false;
  }
}
